import type { InvoiceLineItem, Prisma } from './_prisma';
import type { State } from './states';
import type { InvoiceLineItemCategory, InvoiceLineItemKind } from './taxes-fees';

export type InvoiceLineItemForResults = Prisma.InvoiceLineItemGetPayload<{
    // select: {
    //     id: true;
    //     name: true;
    // };
}>;

export interface CreateInvoiceLineItemPayload {
    debit: string | null;
    credit: string | null;
    invoiceLineItemCategory: InvoiceLineItemCategory;
    invoiceLineItemKind: InvoiceLineItemKind;
    state: State | null;
    notes: string;
    invoiceId: UUID;
}

export interface ReadMultipleInvoiceLineItemsPayload {
    invoiceLineItemIDs: string[];
}

export interface DeleteMultipleInvoiceLineItemsPayload {
    invoiceLineItemIDs: string[];
}

export interface UpdateInvoiceLineItemPayload {
    debit?: string | null;
    credit?: string | null;
    invoiceLineItemKind?: InvoiceLineItemKind;
    state?: State;
    notes?: string;
    invoiceId?: UUID;
}

export type AllInvoiceLineItemsErrorCodes =
    | 'ERROR_FINDING_INVOICE_LINE_ITEMS'
    | 'INVOICE_LINE_ITEMS_NOT_FOUND';
export type CreateInvoiceLineItemsErrorCodes =
    | 'INVOICE_LINE_ITEM_NAME_IN_USE'
    | 'ERROR_CREATING_INVOICE_LINE_ITEM';
export type DeleteMultipleInvoiceLineItemsErrorCodes =
    | 'INVOICE_LINE_ITEMS_NOT_FOUND'
    | 'ERROR_FINDING_INVOICE_LINE_ITEMS'
    | 'ERROR_DELETING_INVOICE_LINE_ITEMS';
export type DeleteInvoiceLineItemErrorCodes =
    | 'INVOICE_LINE_ITEM_NOT_FOUND'
    | 'ERROR_FINDING_INVOICE_LINE_ITEM'
    | 'ERROR_DELETING_INVOICE_LINE_ITEM';
export type FindInvoiceLineItemErrorCodes =
    | 'ERROR_FINDING_INVOICE_LINE_ITEM'
    | 'INVOICE_LINE_ITEM_NOT_FOUND';
export type FindInvoiceLineItemsErrorCodes =
    | 'ERROR_FINDING_INVOICE_LINE_ITEMS'
    | 'NO_INVOICE_LINE_ITEMS_FOUND';
export type SaveInvoiceLineItemErrorCodes = 'ERROR_SAVING_INVOICE_LINE_ITEM';
export type UpdateInvoiceLineItemErrorCodes =
    | 'ERROR_UPDATING_INVOICE_LINE_ITEM'
    | 'INVOICE_LINE_ITEM_NOT_FOUND';

export interface InvoiceLineItemTyped extends InvoiceLineItem {
    invoiceLineItemKind: InvoiceLineItemKind;
    state: State | null;
}

export type InvoiceLineItemKindSortMap = { [index in InvoiceLineItemKind]: number };

export const invoiceLineItemKindSortMap: InvoiceLineItemKindSortMap = {
    premium: 110,
    refund: 110,

    fireMarshallTax: 210,
    premiumTax: 220,

    brokerFee: 310,
    filingFee: 320,
    regulatoryFee: 330,
    serviceCharge: 340,
    serviceFee: 350,
    slasClearinghouseTransactionFee: 360,
    stampingFee: 370,
    surcharge: 380,
    windPoolFee: 390,

    endorsementFee: 410,
    installmentFee: 420,
    latePaymentFee: 430,
    brokerAdminFee: 440,
    nsfFee: 450,
    reinstatementFee: 460,
    cancelationFee: 470,
    paymentProcessingFee: 480,
};

export const sortInvoiceLineItems = (a: InvoiceLineItemTyped, b: InvoiceLineItemTyped): number => {
    const adjustedA = a.debit
        ? invoiceLineItemKindSortMap[a.invoiceLineItemKind]
        : invoiceLineItemKindSortMap[a.invoiceLineItemKind] + 5;

    const adjustedB = b.debit
        ? invoiceLineItemKindSortMap[b.invoiceLineItemKind]
        : invoiceLineItemKindSortMap[b.invoiceLineItemKind] + 5;

    return adjustedA - adjustedB;
};
